import { ImagePlus, Users } from "@digital-twins/design-system/icons";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import type { CreativeUploadKindProps } from "@/types/creative-library";

export function CreativeUploadKind({
  identity,
  disabled,
  onChange,
}: CreativeUploadKindProps) {
  const { t } = useTranslation("app");
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="creative-upload-kind">
      {[false, true].map((character) => (
        <Button
          key={String(character)}
          type="button"
          variant="outline"
          className={
            identity === character
              ? "gap-2 border-primary bg-primary/5 text-primary"
              : "gap-2"
          }
          disabled={disabled}
          aria-pressed={identity === character}
          onClick={() => onChange(character)}
        >
          {character ? (
            <Users className="h-4 w-4" />
          ) : (
            <ImagePlus className="h-4 w-4" />
          )}
          {t(
            character
              ? "creativeLibrary.modelMascotUpload"
              : "creativeLibrary.imageReferenceUpload",
          )}
        </Button>
      ))}
    </div>
  );
}
